import { lazy } from 'react';
const WaybillForm = lazy(() =>
  import('../features/waybill-form/ui/WaybillForm').then((module) => ({
    default: module.WaybillForm,
  }))
);
const FacturaForm = lazy(() =>
  import('../features/factura-form/ui/FacturaForm').then((module) => ({
    default: module.FacturaForm,
  }))
);
const WybillPDF = lazy(() =>
  import('../features/waybill-form/ui/WybillPDF').then((module) => ({
    default: module.WybillPDF,
  }))
);
const FactorPDF = lazy(() =>
  import('../features/factura-form/ui/FactorPDF').then((module) => ({
    default: module.FactorPDF,
  }))
);
// ESLATMA PERMISSION BERILADIGAN JOYDA, RATHNING / DAN KEYINGI BIRINCHI QIYMATI PERMISION STRING ICHIDA BOLISHI SHART
const routes = [
  {
    path: '/',
    component: lazy(() => import('../pages/Dashboard')),
    meta: {
      title: 'Dashboard',
      icon: 'DashboardIcon',
      permission: 'admin/order/index',
    },
  },
  {
    path: '/orders',
    component: lazy(() => import('../pages/Orders')),
    meta: {
      title: 'Orders',
      icon: 'ShoppingFilled',
      permission: 'admin/order/index',
    },
    noSub: true,
    children: [
      {
        path: '/orders/:id',
        component: lazy(() => import('../pages/Orders/Details')),
      },
      {
        path: '/order/waybill/new',
        component: WaybillForm,
      },
      {
        path: '/order/factura/new',
        component: FacturaForm,
      },
      {
        path: '/order/waybill/view',
        component: WybillPDF,
      },
      {
        path: '/order/factura/view',
        component: FactorPDF,
      },
    ],
  },
  {
    path: '/order-list',
    component: lazy(() => import('../pages/OrderList')),
    meta: {
      title: "Seller's orders",
      icon: 'ShoppingFilled',
      permission: 'admin/order/order-list',
    },
    noSub: true,
    children: [
      {
        path: '/order-list/:id',
        component: lazy(() => import('../pages/OrderList/Details')),
      },
    ],
  },

  {
    path: '/products',
    component: lazy(() => import('../pages/Products')),
    meta: {
      title: 'Products',
      icon: 'ProductIcon',
      permission: 'admin/element/index',
    },
    noSub: true,

    children: [
      {
        path: '/products/:id',
        component: lazy(() => import('../pages/Products/Details')),
      },
      {
        path: '/preview/:id',
        component: lazy(() => import('../pages/Products/Preview')),
      },
    ],
  },
  {
    path: '/products2',
    component: lazy(() => import('../pages/Products2')),
    meta: {
      title: 'Products2',
      icon: 'ProductIcon',
      permission: 'admin/element/index',
      hidden: true, // Sidebar'da ko'rinmaydi
    },
    noSub: true,

    children: [
      {
        path: '/products2/:id',
        component: lazy(() => import('../pages/Products2/Details')),
      },
      {
        path: '/preview2/:id',
        component: lazy(() => import('../pages/Products2/Preview')),
      },
    ],
  },
  {
    path: '/documents',
    component: lazy(() => import('../pages/Documents')),
    meta: {
      title: 'Documents',
      icon: 'FileOutlined',
      permission: 'admin/contract/index',
    },
  },
  {
    path: '/categories',
    component: lazy(() => import('../pages/Settings/Categories')),
    meta: {
      title: 'Settings',
      icon: 'SettingOutlined',
      permission: '',
    },
    children: [
      {
        path: '/category',
        component: lazy(() => import('../pages/Settings/Categories')),
        meta: {
          title: 'Categories',
          icon: '',
          permission: 'admin/category/index',
        },
        children: [
          {
            path: '/category/:id',
            component: lazy(() => import('../pages/Settings/Categories')),
            meta: {
              permission: 'admin/category/index',
            },
          },
        ],
      },
      {
        path: '/catalog',
        component: lazy(() => import('../pages/Settings/Catalog')),
        meta: {
          title: 'Catalog',
          icon: '',
          permission: 'admin/catalog/index',
        },
      },
      {
        path: '/meta-data-group',
        component: lazy(() => import('../pages/Settings/MetaDataGroup')),
        meta: {
          title: 'Meta data Group',
          icon: '',
          permission: 'admin/meta-data-group/index',
        },
      },
      // {
      //   path: "/meta-data",
      //   component: lazy(() => import("../pages/Settings/MetaData")),
      //   meta: {
      //     title: "Meta data",
      //     icon: "",
      //     permission: "admin/meta-data/index",
      //   },
      // },
      {
        path: '/unit',
        component: lazy(() => import('../pages/Settings/Unit')),
        meta: {
          title: 'Unit',
          icon: '',
          permission: 'admin/unit/index',
        },
        children: [
          {
            path: '/unit/:id',
            component: lazy(() => import('../pages/Settings/Unit')),
            meta: {
              permission: 'admin/unit/index',
            },
          },
        ],
      },
      {
        path: '/attribute',
        component: lazy(() => import('../pages/Settings/Attribute')),
        meta: {
          title: 'Attribute',
          icon: '',
          permission: 'admin/attribute/index',
        },
        children: [
          {
            path: '/attribute/:id',
            component: lazy(() => import('../pages/Settings/Characteristic')),
            meta: {
              permission: 'admin/characteristic/index',
            },
          },
        ],
      },
      {
        path: '/brand',
        component: lazy(() => import('../pages/Settings/Brand')),
        meta: {
          title: 'Brand',
          icon: '',
          permission: 'admin/brand/index',
        },
      },
      {
        path: '/newsletter',
        component: lazy(() => import('../pages/Settings/NewsLetter')),
        meta: {
          title: 'News Letter',
          icon: '',
          permission: 'admin/newsletter/index',
        },
      },

      // {
      //   path: "/characteristic",
      //   component: lazy(() => import("../pages/Settings/Characteristic")),
      //   meta: {
      //     title: "Characteristic",
      //     icon: "",
      //     permission: "admin/characteristic/index",
      //   },
      // },
      {
        path: '/role',
        component: lazy(() => import('../pages/Settings/Role')),
        meta: {
          title: 'Role',
          icon: '',
          permission: 'admin/role/index',
        },
      },
      {
        path: '/permission-group',
        component: lazy(() => import('../pages/Settings/PermissionGroup')),
        meta: {
          title: 'Permission Group',
          icon: '',
          permission: 'admin/permission-group/index',
        },
      },
      // {
      //   path: "/permission",
      //   component: lazy(() => import("../pages/Settings/Permission")),
      //   meta: {
      //     title: "Permission",
      //     icon: "",
      //     permission: "admin/permission/index",
      //   },
      // },
      {
        path: '/day-offs',
        component: lazy(() => import('../pages/Settings/DayOffs')),
        meta: {
          title: 'Day Offs',
          icon: '',
          permission: 'admin/day-offs/index',
        },
      },
      {
        path: '/staff',
        component: lazy(() => import('../pages/Settings/Staff')),
        meta: {
          title: 'Staff ',
          icon: '',
          permission: 'admin/staff/index',
        },
      },
      {
        path: '/banner',
        component: lazy(() => import('../pages/Settings/Banner')),
        meta: {
          title: 'Banner',
          icon: '',
          permission: 'admin/banner/index',
        },
      },
      {
        path: '/company',
        component: lazy(() => import('../pages/Settings/Company')),
        meta: {
          title: 'Company',
          icon: '',
          permission: 'admin/company/index',
        },
      },
      {
        path: '/language',
        component: lazy(() => import('../pages/Settings/Language')),
        meta: {
          title: 'Language',
          icon: '',
          permission: 'admin/language/index',
        },
      },
      {
        path: '/city',
        component: lazy(() => import('../pages/Settings/City')),
        meta: {
          title: 'City',
          icon: '',
          permission: 'admin/city/index',
        },
        noSub: true,

        children: [
          {
            path: '/city/:id',
            component: lazy(() => import('../pages/Settings/City')),
          },
        ],
      },

      {
        path: '/delivery-payment',
        component: lazy(() => import('../pages/Settings/DeliveryPayment')),
        meta: {
          title: 'Delivey Payment',
          icon: '',
          permission: 'admin/delivery-payment/index',
        },
      },
    ],
  },
];

export default routes;
